/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserAnswer = /* GraphQL */ `
  mutation CreateUserAnswer(
    $input: CreateUserAnswerInput!
    $condition: ModelUserAnswerConditionInput
  ) {
    createUserAnswer(input: $input, condition: $condition) {
      id
      userId
      answers
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserAnswer = /* GraphQL */ `
  mutation UpdateUserAnswer(
    $input: UpdateUserAnswerInput!
    $condition: ModelUserAnswerConditionInput
  ) {
    updateUserAnswer(input: $input, condition: $condition) {
      id
      userId
      answers
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserAnswer = /* GraphQL */ `
  mutation DeleteUserAnswer(
    $input: DeleteUserAnswerInput!
    $condition: ModelUserAnswerConditionInput
  ) {
    deleteUserAnswer(input: $input, condition: $condition) {
      id
      userId
      answers
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMedicalQuizResult = /* GraphQL */ `
  mutation CreateMedicalQuizResult(
    $input: CreateMedicalQuizResultInput!
    $condition: ModelMedicalQuizResultConditionInput
  ) {
    createMedicalQuizResult(input: $input, condition: $condition) {
      id
      userId
      bestMatches
      worstMatches
      domainScores
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateMedicalQuizResult = /* GraphQL */ `
  mutation UpdateMedicalQuizResult(
    $input: UpdateMedicalQuizResultInput!
    $condition: ModelMedicalQuizResultConditionInput
  ) {
    updateMedicalQuizResult(input: $input, condition: $condition) {
      id
      userId
      bestMatches
      worstMatches
      domainScores
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteMedicalQuizResult = /* GraphQL */ `
  mutation DeleteMedicalQuizResult(
    $input: DeleteMedicalQuizResultInput!
    $condition: ModelMedicalQuizResultConditionInput
  ) {
    deleteMedicalQuizResult(input: $input, condition: $condition) {
      id
      userId
      bestMatches
      worstMatches
      domainScores
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createMBTIQuizResult = /* GraphQL */ `
  mutation CreateMBTIQuizResult(
    $input: CreateMBTIQuizResultInput!
    $condition: ModelMBTIQuizResultConditionInput
  ) {
    createMBTIQuizResult(input: $input, condition: $condition) {
      id
      userId
      personalityType
      recommendedSpecialties
      scoreBreakdown
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateMBTIQuizResult = /* GraphQL */ `
  mutation UpdateMBTIQuizResult(
    $input: UpdateMBTIQuizResultInput!
    $condition: ModelMBTIQuizResultConditionInput
  ) {
    updateMBTIQuizResult(input: $input, condition: $condition) {
      id
      userId
      personalityType
      recommendedSpecialties
      scoreBreakdown
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteMBTIQuizResult = /* GraphQL */ `
  mutation DeleteMBTIQuizResult(
    $input: DeleteMBTIQuizResultInput!
    $condition: ModelMBTIQuizResultConditionInput
  ) {
    deleteMBTIQuizResult(input: $input, condition: $condition) {
      id
      userId
      personalityType
      recommendedSpecialties
      scoreBreakdown
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      name
      email
      username
      yearInMedSchool
      medicalUniversity
      demographics
      chosenSpecialty
      specialtyUpdatedAt
      trainingPath
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      name
      email
      username
      yearInMedSchool
      medicalUniversity
      demographics
      chosenSpecialty
      specialtyUpdatedAt
      trainingPath
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      name
      email
      username
      yearInMedSchool
      medicalUniversity
      demographics
      chosenSpecialty
      specialtyUpdatedAt
      trainingPath
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createIMTDomainProgress = /* GraphQL */ `
  mutation CreateIMTDomainProgress(
    $input: CreateIMTDomainProgressInput!
    $condition: ModelIMTDomainProgressConditionInput
  ) {
    createIMTDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateIMTDomainProgress = /* GraphQL */ `
  mutation UpdateIMTDomainProgress(
    $input: UpdateIMTDomainProgressInput!
    $condition: ModelIMTDomainProgressConditionInput
  ) {
    updateIMTDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteIMTDomainProgress = /* GraphQL */ `
  mutation DeleteIMTDomainProgress(
    $input: DeleteIMTDomainProgressInput!
    $condition: ModelIMTDomainProgressConditionInput
  ) {
    deleteIMTDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCSTDomainProgress = /* GraphQL */ `
  mutation CreateCSTDomainProgress(
    $input: CreateCSTDomainProgressInput!
    $condition: ModelCSTDomainProgressConditionInput
  ) {
    createCSTDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateCSTDomainProgress = /* GraphQL */ `
  mutation UpdateCSTDomainProgress(
    $input: UpdateCSTDomainProgressInput!
    $condition: ModelCSTDomainProgressConditionInput
  ) {
    updateCSTDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteCSTDomainProgress = /* GraphQL */ `
  mutation DeleteCSTDomainProgress(
    $input: DeleteCSTDomainProgressInput!
    $condition: ModelCSTDomainProgressConditionInput
  ) {
    deleteCSTDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createACCSDomainProgress = /* GraphQL */ `
  mutation CreateACCSDomainProgress(
    $input: CreateACCSDomainProgressInput!
    $condition: ModelACCSDomainProgressConditionInput
  ) {
    createACCSDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateACCSDomainProgress = /* GraphQL */ `
  mutation UpdateACCSDomainProgress(
    $input: UpdateACCSDomainProgressInput!
    $condition: ModelACCSDomainProgressConditionInput
  ) {
    updateACCSDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteACCSDomainProgress = /* GraphQL */ `
  mutation DeleteACCSDomainProgress(
    $input: DeleteACCSDomainProgressInput!
    $condition: ModelACCSDomainProgressConditionInput
  ) {
    deleteACCSDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createNeuroSurgDomainProgress = /* GraphQL */ `
  mutation CreateNeuroSurgDomainProgress(
    $input: CreateNeuroSurgDomainProgressInput!
    $condition: ModelNeuroSurgDomainProgressConditionInput
  ) {
    createNeuroSurgDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateNeuroSurgDomainProgress = /* GraphQL */ `
  mutation UpdateNeuroSurgDomainProgress(
    $input: UpdateNeuroSurgDomainProgressInput!
    $condition: ModelNeuroSurgDomainProgressConditionInput
  ) {
    updateNeuroSurgDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteNeuroSurgDomainProgress = /* GraphQL */ `
  mutation DeleteNeuroSurgDomainProgress(
    $input: DeleteNeuroSurgDomainProgressInput!
    $condition: ModelNeuroSurgDomainProgressConditionInput
  ) {
    deleteNeuroSurgDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createRadiologyDomainProgress = /* GraphQL */ `
  mutation CreateRadiologyDomainProgress(
    $input: CreateRadiologyDomainProgressInput!
    $condition: ModelRadiologyDomainProgressConditionInput
  ) {
    createRadiologyDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateRadiologyDomainProgress = /* GraphQL */ `
  mutation UpdateRadiologyDomainProgress(
    $input: UpdateRadiologyDomainProgressInput!
    $condition: ModelRadiologyDomainProgressConditionInput
  ) {
    updateRadiologyDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteRadiologyDomainProgress = /* GraphQL */ `
  mutation DeleteRadiologyDomainProgress(
    $input: DeleteRadiologyDomainProgressInput!
    $condition: ModelRadiologyDomainProgressConditionInput
  ) {
    deleteRadiologyDomainProgress(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCategoryPointsRecord = /* GraphQL */ `
  mutation CreateCategoryPointsRecord(
    $input: CreateCategoryPointsRecordInput!
    $condition: ModelCategoryPointsRecordConditionInput
  ) {
    createCategoryPointsRecord(input: $input, condition: $condition) {
      id
      userId
      trainingPath
      categoriesData
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateCategoryPointsRecord = /* GraphQL */ `
  mutation UpdateCategoryPointsRecord(
    $input: UpdateCategoryPointsRecordInput!
    $condition: ModelCategoryPointsRecordConditionInput
  ) {
    updateCategoryPointsRecord(input: $input, condition: $condition) {
      id
      userId
      trainingPath
      categoriesData
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteCategoryPointsRecord = /* GraphQL */ `
  mutation DeleteCategoryPointsRecord(
    $input: DeleteCategoryPointsRecordInput!
    $condition: ModelCategoryPointsRecordConditionInput
  ) {
    deleteCategoryPointsRecord(input: $input, condition: $condition) {
      id
      userId
      trainingPath
      categoriesData
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createPathfinderIMTDomainScore = /* GraphQL */ `
  mutation CreatePathfinderIMTDomainScore(
    $input: CreatePathfinderIMTDomainScoreInput!
    $condition: ModelPathfinderIMTDomainScoreConditionInput
  ) {
    createPathfinderIMTDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePathfinderIMTDomainScore = /* GraphQL */ `
  mutation UpdatePathfinderIMTDomainScore(
    $input: UpdatePathfinderIMTDomainScoreInput!
    $condition: ModelPathfinderIMTDomainScoreConditionInput
  ) {
    updatePathfinderIMTDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePathfinderIMTDomainScore = /* GraphQL */ `
  mutation DeletePathfinderIMTDomainScore(
    $input: DeletePathfinderIMTDomainScoreInput!
    $condition: ModelPathfinderIMTDomainScoreConditionInput
  ) {
    deletePathfinderIMTDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createPathfinderCSTDomainScore = /* GraphQL */ `
  mutation CreatePathfinderCSTDomainScore(
    $input: CreatePathfinderCSTDomainScoreInput!
    $condition: ModelPathfinderCSTDomainScoreConditionInput
  ) {
    createPathfinderCSTDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePathfinderCSTDomainScore = /* GraphQL */ `
  mutation UpdatePathfinderCSTDomainScore(
    $input: UpdatePathfinderCSTDomainScoreInput!
    $condition: ModelPathfinderCSTDomainScoreConditionInput
  ) {
    updatePathfinderCSTDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePathfinderCSTDomainScore = /* GraphQL */ `
  mutation DeletePathfinderCSTDomainScore(
    $input: DeletePathfinderCSTDomainScoreInput!
    $condition: ModelPathfinderCSTDomainScoreConditionInput
  ) {
    deletePathfinderCSTDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createPathfinderACCSDomainScore = /* GraphQL */ `
  mutation CreatePathfinderACCSDomainScore(
    $input: CreatePathfinderACCSDomainScoreInput!
    $condition: ModelPathfinderACCSDomainScoreConditionInput
  ) {
    createPathfinderACCSDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePathfinderACCSDomainScore = /* GraphQL */ `
  mutation UpdatePathfinderACCSDomainScore(
    $input: UpdatePathfinderACCSDomainScoreInput!
    $condition: ModelPathfinderACCSDomainScoreConditionInput
  ) {
    updatePathfinderACCSDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePathfinderACCSDomainScore = /* GraphQL */ `
  mutation DeletePathfinderACCSDomainScore(
    $input: DeletePathfinderACCSDomainScoreInput!
    $condition: ModelPathfinderACCSDomainScoreConditionInput
  ) {
    deletePathfinderACCSDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createPathfinderNeuroSurgDomainScore = /* GraphQL */ `
  mutation CreatePathfinderNeuroSurgDomainScore(
    $input: CreatePathfinderNeuroSurgDomainScoreInput!
    $condition: ModelPathfinderNeuroSurgDomainScoreConditionInput
  ) {
    createPathfinderNeuroSurgDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePathfinderNeuroSurgDomainScore = /* GraphQL */ `
  mutation UpdatePathfinderNeuroSurgDomainScore(
    $input: UpdatePathfinderNeuroSurgDomainScoreInput!
    $condition: ModelPathfinderNeuroSurgDomainScoreConditionInput
  ) {
    updatePathfinderNeuroSurgDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePathfinderNeuroSurgDomainScore = /* GraphQL */ `
  mutation DeletePathfinderNeuroSurgDomainScore(
    $input: DeletePathfinderNeuroSurgDomainScoreInput!
    $condition: ModelPathfinderNeuroSurgDomainScoreConditionInput
  ) {
    deletePathfinderNeuroSurgDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createPathfinderRadiologyDomainScore = /* GraphQL */ `
  mutation CreatePathfinderRadiologyDomainScore(
    $input: CreatePathfinderRadiologyDomainScoreInput!
    $condition: ModelPathfinderRadiologyDomainScoreConditionInput
  ) {
    createPathfinderRadiologyDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePathfinderRadiologyDomainScore = /* GraphQL */ `
  mutation UpdatePathfinderRadiologyDomainScore(
    $input: UpdatePathfinderRadiologyDomainScoreInput!
    $condition: ModelPathfinderRadiologyDomainScoreConditionInput
  ) {
    updatePathfinderRadiologyDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePathfinderRadiologyDomainScore = /* GraphQL */ `
  mutation DeletePathfinderRadiologyDomainScore(
    $input: DeletePathfinderRadiologyDomainScoreInput!
    $condition: ModelPathfinderRadiologyDomainScoreConditionInput
  ) {
    deletePathfinderRadiologyDomainScore(input: $input, condition: $condition) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCalendarEvent = /* GraphQL */ `
  mutation CreateCalendarEvent(
    $input: CreateCalendarEventInput!
    $condition: ModelCalendarEventConditionInput
  ) {
    createCalendarEvent(input: $input, condition: $condition) {
      id
      owner
      title
      description
      start
      end
      location
      eventType
      staff
      courseCode
      backgroundColor
      borderColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCalendarEvent = /* GraphQL */ `
  mutation UpdateCalendarEvent(
    $input: UpdateCalendarEventInput!
    $condition: ModelCalendarEventConditionInput
  ) {
    updateCalendarEvent(input: $input, condition: $condition) {
      id
      owner
      title
      description
      start
      end
      location
      eventType
      staff
      courseCode
      backgroundColor
      borderColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCalendarEvent = /* GraphQL */ `
  mutation DeleteCalendarEvent(
    $input: DeleteCalendarEventInput!
    $condition: ModelCalendarEventConditionInput
  ) {
    deleteCalendarEvent(input: $input, condition: $condition) {
      id
      owner
      title
      description
      start
      end
      location
      eventType
      staff
      courseCode
      backgroundColor
      borderColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDailyActivity = /* GraphQL */ `
  mutation CreateDailyActivity(
    $input: CreateDailyActivityInput!
    $condition: ModelDailyActivityConditionInput
  ) {
    createDailyActivity(input: $input, condition: $condition) {
      id
      owner
      date
      kind
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDailyActivity = /* GraphQL */ `
  mutation UpdateDailyActivity(
    $input: UpdateDailyActivityInput!
    $condition: ModelDailyActivityConditionInput
  ) {
    updateDailyActivity(input: $input, condition: $condition) {
      id
      owner
      date
      kind
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDailyActivity = /* GraphQL */ `
  mutation DeleteDailyActivity(
    $input: DeleteDailyActivityInput!
    $condition: ModelDailyActivityConditionInput
  ) {
    deleteDailyActivity(input: $input, condition: $condition) {
      id
      owner
      date
      kind
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
